import React from 'react'
import BenefitCom from './BenefitCom'
import { motion } from 'framer-motion'
import { AccountBalance, BusinessCenter, CalendarMonth, CheckCircle, Devices, Home, NoEncryption, Savings, TouchApp, VerifiedUser, Visibility } from '@mui/icons-material'

function Benefit() {
  const container = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: { staggerChildren: 0.2 },
    },
  }

  const item = {
    hidden: { opacity: 0, y: 30 },
    show: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } },
  }

  return (
    <motion.section
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, amount: 0.2 }}
      variants={container}
      className="px-6 sm:px-24 py-10 sm:py-20 bg-text-gray"
    >
      <motion.h1
        variants={item}
        className="text-[24px] sm:text-[44px] text-text-color1 mb-7"
      >
        Why Halal Wealth Asset Financing?
      </motion.h1>

      <motion.div
        variants={container}
        className="grid sm:grid-cols-2 gap-5"
      >
        <motion.div variants={item}>
          <BenefitCom
            color={" bg-[#E6DAFC]"}
            icon={<AccountBalance />}
            header={"Interest-Free Installments"}
            con={
              "Get to purchase items and pay in smaller, manageable amounts over time without paying any extra interest. Own what you need with flexible, interest-free installments. Transparent, ethical, and Shariah-compliant financing, no hidden charges, no extra costs!"
            }
          />
        </motion.div>

        <motion.div variants={item}>
          <BenefitCom
            color={" bg-[#D1F0E1]"}
            icon={<CalendarMonth />}
            header={"Flexible Payment Plans"}
            con={
              "Get the assets you need with flexible, interest-free payment plans. Customize your installments to fit your budget and financial goals. Enjoy a stress-free path to ownership while staying true to your values."
            }
          />
        </motion.div>

        <motion.div variants={item} className="hidden sm:block">
          <BenefitCom
            color={" bg-[#D1F0E1]"}
            icon={<VerifiedUser />}
            header={"Ethical Financing"}
            con={
              "Embrace a responsible approach to financing. Our interest-free installment options reflect our commitment to ethical and fair financial practices, giving you a stress-free way to acquire the items you desire."
            }
          />
        </motion.div>

        <motion.div variants={item}>
          <BenefitCom
            color={" bg-[#E6DAFC]"}
            icon={<Visibility />}
            header={"Transparent Terms"}
            con={
              "We believe in transparency. Our installment plans come with clear terms and conditions, so you know exactly what to expect. No hidden fees or surprises – just straightforward, interest-free financing for your purchases."
            }
          />
        </motion.div>

        <motion.div variants={item} className="hidden sm:block">
          <BenefitCom
            color={" bg-[#D1F0E1]"}
            icon={<Devices />}
            header={"Flexible Asset Plans"}
            con={
              "Finance tools, gadgets, appliances, or business equipment in stress-free monthly payments - without touching interest."
            }
          />
        </motion.div>

        <motion.div variants={item}>
          <BenefitCom
            color={" bg-[#E6DAFC]"}
            icon={<CheckCircle />}
            header={"Shariah-Compliant by Design"}
            con={
              "All financing is structured to meet Islamic financial ethics: no riba, no uncertainty, no hidden clauses."
            }
          />
        </motion.div>

        <motion.div variants={item} className="hidden sm:block">
          <BenefitCom
            color={" bg-[#D1F0E1]"}
            icon={<BusinessCenter />}
            header={"Business & Personal Use"}
            con={
              "Use asset financing for everything from home essentials to scaling your halal side hustle. You're covered, ethically."
            }
          />
        </motion.div>

        <motion.div variants={item}>
          <BenefitCom
            color={" bg-[#E6DAFC]"}
            icon={<Home />}
            header={"Own, Don’t Rent"}
            con={
              "Every payment moves you closer to ownership - no leasing traps or rent-to-nowhere deals."
            }
          />
        </motion.div>

        <motion.div variants={item} className="hidden sm:block">
          <BenefitCom
            color={" bg-[#D1F0E1]"}
            icon={<NoEncryption />}
            header={"Zero Hidden Costs"}
            con={
              "What you see is what you pay. Transparent pricing, clear repayment structure, and no shady conditions."
            }
          />
        </motion.div>

        <motion.div variants={item}>
          <BenefitCom
            color={" bg-[#E6DAFC]"}
            icon={<TouchApp />}
            header={"Simple Application Process"}
            con={
              "Apply online in minutes. Get reviewed quickly. Approvals are based on trust, not credit score algorithms."
            }
          />
        </motion.div>

        <motion.div variants={item} className="hidden sm:block">
          <BenefitCom
            color={" bg-[#D1F0E1]"}
            icon={<Savings />}
            header={"Barakah-Backed Repayment Options"}
            con={
              "Choose flexible repayment terms that align with your income. Consistency is rewarded with non-cash bonuses."
            }
          />
        </motion.div>
      </motion.div>
    </motion.section>
  )
}

export default Benefit
